/**
 * @generated SignedSource<<ec02df7d2336eb09a4262f36a63bf4c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "participativeModuleSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "participativeModuleSlug",
    "variableName": "participativeModuleSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "CityWalkContribution",
  "kind": "LinkedField",
  "name": "activeContribution",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CityWalkCompleteFinalizeContributionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CityWalk",
        "kind": "LinkedField",
        "name": "cityWalk",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CityWalkCompleteFinalizeContributionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CityWalk",
        "kind": "LinkedField",
        "name": "cityWalk",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1c7a04c3d3fb348a7d7b1f78a70c173a",
    "id": null,
    "metadata": {},
    "name": "CityWalkCompleteFinalizeContributionQuery",
    "operationKind": "query",
    "text": "query CityWalkCompleteFinalizeContributionQuery(\n  $participativeModuleSlug: ID!\n) {\n  cityWalk(participativeModuleSlug: $participativeModuleSlug) {\n    activeContribution {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "77ef86e9381b7b86f5b6be6dff3e946d";

module.exports = node;
